<template>
	<div class="recharge_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.go(-1)" />
			<div class="big_tit">
				{{ $t('account.addAccount') }}
			</div>
		</div>
		<div class="wrap_box warp1">
			<div class="item">
				<div class="ari_font">
					{{ $t('account.bank') }}：
				</div>
				<van-dropdown-menu>
					<van-dropdown-item v-model="value" :options="wallets" @change="onChange()" />
				</van-dropdown-menu>
			</div>
			<!-- 虚拟货币 -->
			<div v-show="type == 1">
				<div class="item">
					<div class="ari_font">
						{{ $t('account.address') }}：
					</div>
					<input v-model="bank.account" class="card" type="text" :placeholder="$t('account.addressTit')">
				</div>
				<!-- <div>虚拟货币</div> -->
				<div class="qrcode">
					<div>{{ $t('account.qrcodetips') }}</div>
					<div class="qrcode_img">
						<!-- <span>QR code</span> -->
						<van-uploader v-model="fileList" multiple :max-count="1" class="upload"
							:max-size="2 * 1024 * 1024" :after-read="afterRead" :before-read="beforeRead"
							@oversize="onOversize" />
					</div>
				</div>
			</div>
			<!-- 支付宝 -->
			<div v-show="type == 2">
				<div class="item">
					<div class="ari_font">
						{{ $t('accountUsdt.name') }}
					</div>
					<input v-model="bank.name" class="card" type="text" placeholder="请输入支付宝实名">
				</div>
				<div class="item">
					<div class="ari_font">
						{{ $t('accountUsdt.alipayAccount') }}
					</div>
					<input v-model="bank.account" class="card" type="text"
						:placeholder="$t('accountUsdt.alipayAccountEmpty')">
				</div>
				<!-- <div class="qrcode">
					<div>{{ $t('accountUsdt.alipayQrcode') }}</div>
					<div class="qrcode_img">
						<van-uploader v-model="fileList" multiple :max-count="1" class="upload"
							:max-size="2 * 1024 * 1024" :after-read="afterRead" :before-read="beforeRead"
							@oversize="onOversize" />
					</div>
				</div> -->
			</div>
			<!-- 微信 -->
			<div v-show="type == 3">
				<div class="item">
					<div class="ari_font">
						{{ $t('accountUsdt.name') }}
					</div>
					<input v-model="bank.name" class="card" type="text" placeholder="请输入微信实名">
				</div>
				<div class="item">
					<div class="ari_font">
						{{ $t('accountUsdt.wechatAccount') }}
					</div>
					<input v-model="bank.account" class="card" type="text"
						:placeholder="$t('accountUsdt.wechatAccountEmpty')">
				</div>
				<div class="qrcode">
					<div>{{ $t('accountUsdt.wechatQrcode') }}</div>
					<div class="qrcode_img">
						<van-uploader v-model="fileList" multiple :max-count="1" class="upload"
							:max-size="2 * 1024 * 1024" :after-read="afterRead" :before-read="beforeRead"
							@oversize="onOversize" />
					</div>
				</div>
			</div>
			<!-- 银行卡 -->
			<div v-show="type == 4">
				<div class="item">
					<div class="ari_font">
						{{ $t('accountUsdt.name') }}
					</div>
					<input v-model="bank.name" class="card" type="text" :placeholder="$t('accountUsdt.nameEmpty')">
				</div>
				<div class="item">
					<div class="ari_font">
						{{ $t('accountUsdt.account') }}
					</div>
					<input v-model="bank.account" class="card" type="text"
						:placeholder="$t('accountUsdt.accountEmpty')">
				</div>
				<div class="item">
					<div class="ari_font">
						银行名称：
					</div>
					<input v-model="bank.area" class="card" type="text" placeholder="请输入银行名称">
				</div>
				<!--        <div class="qrcode">
          <div>银行卡照</div>
          <div class="qrcode_img">
            <van-uploader v-model="fileList" multiple :max-count="1" class="upload" :max-size="2 * 1024 * 1024"
              :after-read="afterRead" :before-read="beforeRead" @oversize="onOversize" />
          </div>
        </div> -->
				<!-- <div class="item">
          <div class="ari_font">
            {{ $t('accountUsdt.area') }}
          </div>
          <van-dropdown-menu>
            <van-dropdown-item v-model="value_bank" :options="banks" @change="onChangeB()" />
          </van-dropdown-menu>
        </div> -->
				<!--<div class="item">
					<div class="ari_font">{{$t('accountUsdt.area')}}</div>
					<input class="card" type="text" v-model="bank.area" :placeholder="$t('accountUsdt.areaEmpty')">
					
				</div>-->
			</div>
		</div>
		<div v-show="type == 2" class="basic_btn" @click="submitBtnCodeZfb">
			立即绑定
		</div>
		<div v-show="type == 3" class="basic_btn" @click="submitBtnCodeWx">
			立即绑定
		</div>
		<div v-show="type == 4" class="basic_btn" @click="submitBtnBank">
			立即绑定
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch'
	import Api from "../../interface/index";
	import {
		Overlay,
		Uploader,
		Button,
		DropdownMenu,
		DropdownItem,
		Toast
	} from 'vant';
	import axios from 'axios'

	Vue.use(Overlay).use(Uploader).use(Button).use(DropdownMenu).use(DropdownItem);
	export default {
		name: "AddcountUsdt",
		data() {
			return {
				bank: {
					account: '',
					name: '',
					area: '',
					bank: '',
					img: '',
					type: 1,
					banks_id: 0,
					wid: 0
				},
				fileList: [],
				type: 1,
				value: 0,
				value_bank: 0,
				wallets: [],
				banks: [],
				data: {},
			};
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
			this.getUser();
		},
		methods: {
			start() {
				Fetch('/user/wallet_type', {}).then(r => {

					let wallet = r.data;
					// let banks = r.data.banks;
					this.bank.bank = wallet[0].name;
					this.bank.type = wallet[0].type;
					this.type = wallet[0].type;
					this.bank.wid = wallet[0].id;
					for (let i = 0; i < wallet.length; i++) {
						this.wallets.push({
							text: wallet[i].name,
							value: i,
							type: wallet[i].type,
							wid: wallet[i].id
						})
					}
					// for (let i = 0; i < banks.length; i++) {
					//   this.banks.push({
					//     text: banks[i].name,
					//     value: i,
					//     code: banks[i].code,
					//     wid: banks[i].id
					//   })
					// }
					this.setDefaultType();
				})
			},
			setDefaultType() {
				const typeParam = this.$route.query.type;
				if (typeParam) {
					const targetType = parseInt(typeParam);
					// 在wallets中查找对应类型的索引
					const index = this.wallets.findIndex(item => item.type === targetType);
					if (index !== -1) {
						this.value = index;
						this.type = this.wallets[index].type;
						this.bank.bank = this.wallets[index].text;
						this.bank.type = this.wallets[index].type;
						this.bank.wid = this.wallets[index].wid;
					}
				}
			},
			getUser() {
				Fetch('/user/info').then((r) => {
					this.data = r.data;
				});
			},
			submitBtnCodeZfb() {
				if (!this.bank.name) {
					this.$toast({
						className: "toastName",
						message: '请输入姓名',
					});
					return false;
				}
				if (!this.bank.account) {
					this.$toast({
						className: "toastName",
						message: '请输入支付宝账号',
					});
					return false;
				}
				// if (!this.fileList || this.fileList.length == 0) {
				//     this.$toast({
				//     	className: "toastName",
				//     	message: '请上传支付宝收款码',
				//     });
				//     return false;
				// }
				// if (this.data.is_open_zfb != 1) {
				// 	this.$toast({
				// 		className: "toastName",
				// 		message: '请先在首页开通支付宝钱包',
				// 	});
				// 	return false;
				// }
				Fetch('/user/bank_add', {
					...this.bank
				}).then(r => {
					this.$router.go(-1);
				})
			},
			submitBtnCodeWx() {
				if (!this.bank.name) {
					this.$toast({
						className: "toastName",
						message: '请输入姓名',
					});
					return false;
				}
				if (!this.bank.account) {
					this.$toast({
						className: "toastName",
						message: '请输入微信账号',
					});
					return false;
				}
				if (!this.fileList || this.fileList.length == 0) {
					this.$toast({
						className: "toastName",
						message: '请上传微信收款码',
					});
					return false;
				}
				if (this.data.is_open_wx != 1) {
					this.$toast({
						className: "toastName",
						message: '请先在首页开通微信钱包',
					});
					return false;
				}
				Fetch('/user/bank_add', {
					...this.bank
				}).then(r => {
					this.$router.go(-1);
				})
			},
			submitBtnBank() {
				if (!this.bank.name) {
					this.$toast({
						className: "toastName",
						message: '请输入姓名',
					});
					return false;
				}
				if (!this.bank.area || this.bank.area.trim().length < 2) {
					this.$toast({
						className: "toastName",
						message: '请输入有效的银行名称',
					});
					return false;
				}
				if (!this.bank.account) {
					this.$toast({
						className: "toastName",
						message: '请输入银行卡号',
					});
					return false;
				}
				if (this.bank.account.length < 15 || this.bank.account.length > 19) {
					this.$toast({
						className: "toastName",
						message: '银行卡号长度应为15-19位',
					});
					return false;
				}

				if (!/^\d+$/.test(this.bank.account)) {
					this.$toast({
						className: "toastName",
						message: '银行卡号必须全为数字',
					});
					return false;
				}
				// if (!this.bank.img) {
				//     this.$notify(this.$t('account.qrcodeEmpty'));
				//     return;
				// }
				Fetch('/user/bank_add', {
					...this.bank
				}).then(r => {
					this.$router.go(-1);
				})
			},
			onOversize(file) {
				this.$toast(this.$t('account.within2megabytes'));
			},
			beforeRead(file) {
				if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
					this.$toast(this.$t('account.supportPicture'));
					return false;
				}
				return true;
			},
			afterRead(file) {
				let formData = new FormData();
				formData.append('language', this.$i18n.locale || "zh_cn");
				formData.append('file', file.file);
				formData.append('id', this.$router.history.current.params.id);
				formData.append('token', localStorage.getItem('token'));
				Toast.loading({
					forbidClick: true,
					duration: 20000
				});
				axios.post(Api.commonUrl + "/api/index/bank_link_upload", formData).then((r) => {
					Toast.clear();
					if (r.data.code === 1) {
						this.bank.img = r.data.data;
					} else {
						if (r.data.info) {
							this.$toast(r.data.info);
						} else {
							this.$toast(this.$t('account.uploadFail'));
						}
					}
				});
			},
			onChange() {
				this.type = this.wallets[this.value]['type'];
				this.bank.bank = this.wallets[this.value]['text'];
				this.bank.type = this.wallets[this.value]['type'];
				this.bank.wid = this.wallets[this.value]['wid'];

				// if (this.bank.type == 4) {
				//   // 默认银行
				//   this.bank.banks_id = this.banks[0]['wid'];
				//   console.log(this.bank)

				// }

				console.log(this.bank, this.wallets, "~~!!@")
			},
			onChangeB() {
				console.log(this.value_bank)
				console.log(this.banks[this.value_bank]['wid'])
				this.bank.banks_id = this.banks[this.value_bank]['wid'];
			}

		}
	};
</script>

<style lang="less" scoped>
	// /deep/ .van-overlay{
	// 	background-color:hsla(0,0%,100%,0);
	// }
	//    /deep/ .van-dropdown-menu {
	//        position: relative;
	// 	width: 100%;
	//        z-index: 10;
	//        color: #CCCCCC;
	//    }

	/deep/ .van-dropdown-menu__bar {
		box-shadow: none;
		// position: relative;
		// z-index: 10;
		// height: 34px;
		// border: 1px solid #D9D9D9;
		// border-radius: 4px;
		// text-align: left;
	}

	//    /deep/ .van-dropdown-item--down {
	//        margin: 0 auto;
	//        z-index: 12;
	//        transform: translateX(4px);
	//    }

	// /deep/ .van-dropdown-menu__item {
	//     justify-content: flex-start;
	//     color: #ccc;
	//     background-color: #fff;
	// }

	//    /deep/ .van-dropdown-menu__title {
	//        width: 100%;
	//    }

	//    /deep/ .van-dropdown-menu__title::after {
	//        width: 13px;
	//        height: 22px;
	//        transform: none;
	//        background: url(../../assets/images/drop.png) no-repeat center center;
	//        background-size: 100% 100%;
	//        border: none;
	//        opacity: 1;
	//        margin-top: -11px;
	//        right: 10px;
	//    }

	//    /deep/ .van-cell {
	//        padding: 5px 8px;
	//    }

	//    /deep/ .van-cell__title {
	//        flex: 3;
	//        white-space: normal;
	//    }

	//    /deep/ .van-ellipsis {
	//        color: #000;
	//    }

	//    /deep/ .van-dropdown-item__option {
	//        color: #ccc;
	//        border: 1px solid #D9D9D9;
	//        border-bottom: none;
	//        border-radius: 4px;
	//    }

	//    /deep/ .van-dropdown-item__option:last-child {
	//        border-bottom: 1px solid #D9D9D9;
	//    }

	//    /deep/ .van-dropdown-item__option--active.van-dropdown-item__option {
	//        color: #000;

	//        .van-dropdown-item__icon {
	//            color: #E96259;
	//        }
	//    }
	/deep/ .van-button--primary {
		background-color: transparent;
		border: none;
		width: 100%;
		height: 100%;
	}

	/deep/ .van-uploader__input-wrapper {
		width: 100%;
	}

	/deep/ .van-uploader__wrapper {
		width: 100%;
		height: 100%;
	}

	/deep/ .van-uploader__upload {
		width: 100%;
		height: 100%;
		margin: 0;
	}

	/deep/ .van-uploader__preview {
		margin: 0;
	}

	/deep/ .van-uploader__preview-image {
		width: 100%;
		height: 100%;
	}

	.back_left {
		background: url(../../views/images/item/back_b.png) no-repeat center center;
	}

	.big_tit {
		color: #FFF;
	}

	.rela {
		position: relative;
		z-index: 11;
	}

	.warp1 {
		margin-top: 12px;

		.item {
			height: 50px;
			padding: 0 16px;
			font-size: 14px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			border-bottom: 1px solid #ECECEC;

			&:last-child {
				border-bottom: none;
			}

			.card {
			}

			input {
				line-height: 14px;
			}
		}
	}

	.ari_font {
		word-break: keep-all;
		white-space: nowrap;
		height: 20px;
		font-size: 14px;
		font-weight: 600;
		color: rgba(0, 0, 0, .8);
		line-height: 20px;
		margin-right: 5px;
	}

	.basic_btn {
		margin: 75px auto 0 auto;
	}

	.qrcode {
		padding-top: 30px;
		padding-bottom: 30px;
		text-align: center;

		div {
			color: #999;
			font-size: 14px;
			margin-bottom: 20px;
		}

		.upload {
			width: 100%;
			height: 100%;
		}

		.qrcode_img {
			width: 250px;
			height: 250px;
			margin: 0 auto;
			background: linear-gradient(to left, #999, #999) left top no-repeat,
				linear-gradient(to bottom, #999, #999) left top no-repeat,
				linear-gradient(to left, #999, #999) right top no-repeat,
				linear-gradient(to bottom, #999, #999) right top no-repeat,
				linear-gradient(to left, #999, #999) left bottom no-repeat,
				linear-gradient(to bottom, #999, #999) left bottom no-repeat,
				linear-gradient(to left, #999, #999) right bottom no-repeat,
				linear-gradient(to left, #999, #999) right bottom no-repeat;
			background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;

			span {
				line-height: 220px;
			}

			img {
				width: 240px;
				height: 240px;
				position: relative;
				top: -255px;
			}
		}
	}
</style>